import { MyRouter } from 'pages/routes'
import './styles.css'

export const App: React.FC = () => <MyRouter />
